// Toggles an up/down caret for disclosing content
// For use with slideout. Finds the icon embedded
// in the link and flips it to the other version.
$('a[data-disclosure-toggle]').click(function () {
  $(this).find('span.ph-chevron-down, span.ph-chevron-up').toggleClass('ph-chevron-down ph-chevron-up');
});

$('[data-angle-toggle]').click(function () {
  $(this).find('.ph-chevron-down, .ph-chevron-up').toggleClass('ph-chevron-down ph-chevron-up');
});

$('[data-listing-toggle-button]').click(function (e) {
  if ($(e.target).is('a')) { return; }
  $(this).closest('.listing-toggle').toggleClass('listing-toggle--collapsed');
});

$('.listing-collapsing-list__toggle').click(function () {
  $(this).closest('.listing-collapsing-list').toggleClass('listing-collapsing-list--expanded');
});
